/** BRD §5.3 FR-3.2 — the presence states. */
export const STATUSES = ['AVAILABLE', 'FOCUS', 'MEETING', 'BREAK', 'AWAY', 'OFFLINE'];
/**
 * Statuses a user may set by hand. MEETING and OFFLINE are system-derived only;
 * BREAK can be either — walking into the breakroom sets it, and someone taking
 * a break away from their desk can set it themselves.
 */
export const MANUAL_STATUSES = ['AVAILABLE', 'FOCUS', 'BREAK', 'AWAY'];
export function isStatus(value) {
    return typeof value === 'string' && STATUSES.includes(value);
}
export function isManualStatus(value) {
    return typeof value === 'string' && MANUAL_STATUSES.includes(value);
}
export const STATUS_LABELS = {
    AVAILABLE: 'Available',
    FOCUS: 'Focus mode',
    MEETING: 'In a meeting',
    BREAK: 'Taking a break',
    AWAY: 'Away',
    OFFLINE: 'Offline',
};
/**
 * Which statuses accrue tracked working time.
 *
 * Company policy here: AVAILABLE, FOCUS, MEETING and BREAK all count as worked
 * time — breaks are paid, so the clock keeps running through them. Only AWAY is
 * excluded, because idle detection sets it when nobody is at the keyboard
 * (FR-3.4).
 *
 * Break time is still measured into its own bucket and reported separately, so
 * a manager can see how a day was spent even though the total includes it.
 *
 * BRD §11 Q2 leaves the hours-worked policy open. This function is the single
 * switch: moving BREAK out of the list makes breaks unpaid, and every report,
 * export and live counter follows automatically.
 */
export function statusCountsAsWorking(status) {
    return status === 'AVAILABLE' || status === 'FOCUS' || status === 'MEETING' || status === 'BREAK';
}
/** True when the live counter stops advancing — only genuine idle time. */
export function statusIsPaused(status) {
    return status === 'AWAY';
}
export const ZONE_TYPES = ['OPEN', 'FOCUS', 'MEETING', 'BREAK'];
/**
 * Standing in one of these zones derives a status (FR-2.1 + FR-3.2): a meeting
 * room means you are in a meeting, the breakroom means you are on a break.
 * Open floor and focus rooms leave the person's own choice alone.
 */
export const ZONE_DERIVED_STATUS = {
    MEETING: 'MEETING',
    BREAK: 'BREAK',
};
export function statusForZoneType(type) {
    if (!type)
        return null;
    return ZONE_DERIVED_STATUS[type] ?? null;
}
/**
 * Whether a meeting room can be walked into.
 *
 * OPEN is the office default: anyone may join, which is what makes a meeting
 * room useful for the spontaneous conversations this product exists to bring
 * back. PRIVATE is a door — an empty room is still free to take, but once
 * somebody is inside, everyone else has to be let in (FR-2.6, FR-6.7).
 */
export const ZONE_ACCESS = ['OPEN', 'PRIVATE'];
export function zoneAccessOf(zone) {
    // Only a meeting room has a door. Locking the open floor would be a way to
    // partition the office that nothing else in the product expects.
    return zone.type === 'MEETING' && zone.access === 'PRIVATE' ? 'PRIVATE' : 'OPEN';
}
export const FACINGS = ['down', 'up', 'left', 'right'];
//# sourceMappingURL=presence.js.map